import { useState } from 'react';
import PropTypes from 'prop-types';
import { formatAmount } from 'Shared/util/formatters';
import { ToggleRadioGroup, ToggleRadioButton } from 'Shared/components/toggle-radio';
import PieChart from 'Shared/components/charts/pie-chart';
import { useTranslation } from 'Shared/util/custom-hooks';
import { getPieChartDataCount, getPieChartDataAmount } from './ledger-utils';
import styles from './ledger-chart.css';

const AMOUNT = 'AMOUNT';
const COUNT = 'COUNT';

const getChartData = (state, invoices, pT) => (state === AMOUNT
  ? getPieChartDataAmount(invoices, pT)
  : getPieChartDataCount(invoices, pT));

const getChartOptions = (state) => ({
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        const text = data.labels[tooltipItem.index];
        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        return `${text}: ${state === AMOUNT ? formatAmount(value) : value}`;
      },
    },
  },
});


const LedgerPieChart = ({
  invoices,
  onClick,
  legend,
  labelTexts,
}) => {
  const [state, setState] = useState(AMOUNT);
  const t = useTranslation(x => x.invoiceStatus);
  const tg = useTranslation(x => x.global);

  const chartData = getChartData(state, invoices, t);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.radioGroup}>
          <ToggleRadioGroup
            name="pie-chart-tabs"
            value={state}
            handleChange={(e) => setState(e.target.value)}
          >
            <ToggleRadioButton value={AMOUNT} text={tg.balance} />
            <ToggleRadioButton value={COUNT} text={tg.numberOfInvoices} />
          </ToggleRadioGroup>
        </div>
        <div className={styles.chartContainer}>
          <PieChart
            labels={Object.keys(chartData.data)}
            values={Object.values(chartData.data)}
            colors={chartData.colors}
            options={getChartOptions(state)}
            onClick={onClick}
            legend={legend}
            labelTexts={labelTexts}
          />
        </div>
      </div>
    </div>
  );
};

LedgerPieChart.propTypes = {
  invoices: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  legend: PropTypes.shape({
    onClick: PropTypes.func,
    selectedIndex: PropTypes.number,
  }),
  labelTexts: PropTypes.object,
};

export default LedgerPieChart;
